/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*---------------- SECTION FOOTER ----------------*/ 


function handleFooter(){
  console.log(this);
  subList = this.querySelector(".footer__navigation__sublist");
  this.classList.contains("-active") ? (this.classList.remove("-active"), subList.style.setProperty("--max-height", "0")) : (this.classList.add("-active"), subList.style.setProperty("--max-height", subList.scrollHeight + "px"));  
}

/*
function (e, t, i) {
    "use strict";
    i.r(t),
        i.d(t, "default", function () {
            return s;
        });
    class s {
        constructor() {
            (this.elements = document.getElementsByClassName("footer__navigation__list__element")),
                (this.isDesktop = window.matchMedia("(min-width: 1024px)").matches),
                (this.handleClick = (e) => this._handleClick(e)),
                this.initEvents();
        }
        _handleClick(e) {
            if ("a" !== e.target.tagName.toLowerCase()) {
                e.preventDefault();
                const t = e.target.classList.contains("footer__navigation__list__element") ? e.target : e.target.closest(".footer__navigation__list__element"),
                    i = t.querySelector(".footer__navigation__sublist"),
                    s = i.scrollHeight;
                t.classList.contains("-active") ? (t.classList.remove("-active"), i.style.setProperty("--max-height", "0")) : (t.classList.add("-active"), i.style.setProperty("--max-height", s + "px"));
            }
        }
        initEvents() {
            if (!this.isDesktop) for (const e of this.elements) e.addEventListener("click", this.handleClick);
        }
    }
},
function (e, t, i) {
    "use strict";
    i.r(t),
        i.d(t, "default", function () {
            return s;
        });
    class s {
        constructor() {
            (this.close = document.getElementById("closeHelp")), (this.container = document.getElementById("helpContainer")), this.container && ((this.handleClose = (e) => this._handleClose(e)), this.init());
        }
        init() {
            !window.localStorage.getItem("footerHelpClosed") && this.container.classList.contains("-hidden") && (this.container.classList.remove("-hidden"), this.initEvents());
        }
        _handleClose(e) {
            e.preventDefault(),
                this.container.classList.contains("-hidden") ||
                    (this.container.classList.add("-hidden"),
                    setTimeout(() => {
                        this.container.remove(), this.destroy();
                    }, 300)),
                window.localStorage.getItem("footerHelpClosed") || window.localStorage.setItem("footerHelpClosed", !0);
        }
        initEvents() {
            this.close.addEventListener("click", this.handleClose);
        }
        destroy() {
            this.close.removeEventListener("click", this.handleClose);
        }
    }
}
*/